import { Component, OnInit, AfterViewInit } from '@angular/core';
declare let $, jQuery: any;
@Component({
  selector: 'app-header-navigation',
  templateUrl: './header-navigation.component.html',
  styleUrls: ['./header-navigation.component.scss']
})
export class HeaderNavigationComponent implements OnInit, AfterViewInit {

  constructor() { }

  ngOnInit(): void {
  }

  ngAfterViewInit() {
    // navbar
    (function ($) {
      "use strict";

      $(function () {
        var header = $(".start-style");
        $(window).scroll(function () {
          var scroll = $(window).scrollTop();

          if (scroll >= 10) {
            header.removeClass('start-style').addClass("scroll-on");
          } else {
            header.removeClass("scroll-on").addClass('start-style');
          }
        });
      });


      /*---------------------------
    :: Navbar on Scroll
    -----------------------------*/
      $(window).scroll(function () {
        $('header').toggleClass('scrolled', $(this).scrollTop() > 100);
        if ($(this).scrollTop() > 100) {
          $('header').addClass('fixed-top');
        } else {
          $('header').removeClass("fixed-top");
        }
      });

      $(document).ready(function () {
        // Open submenu on click
        $('.dropdown-submenu a.dropdown-toggle').on("click", function (e) {
          $(this).next('ul').toggle();
          e.stopPropagation();
          e.preventDefault();
        });

        // Open submenu on hover
        $('.dropdown-submenu').on("mouseenter", function () {
          $(this).children('.dropdown-menu').show();
        }).on("mouseleave", function () {
          $(this).children('.dropdown-menu').hide();
        });
      });


      $(document).ready(function () {
        $('body.hero-anime').removeClass('hero-anime');
      });

      $('body').on('mouseenter mouseleave', '.nav-item', function (e) {
        if ($(window).width() > 750) {
          var _d = $(e.target).closest('.nav-item'); _d.addClass('show');
          setTimeout(function () {
            _d[_d.is(':hover') ? 'addClass' : 'removeClass']('show');
          }, 1);
          $('.navbar-collapse a').click(function () {
            $(".navbar-collapse").collapse('hide');
          });
        }
      });

      $("#switch").on('click', function () {
        if ($("body").hasClass("dark")) {
          $("body").removeClass("dark");
          $("#switch").removeClass("switched");
        }
        else {
          $("body").addClass("dark");
          $("#switch").addClass("switched");
        }
      });


    })(jQuery);
  }


}
